export default __webpack_public_path__ + "navigation-overview-header-image-960-47d6346cf29a83ef5d6382f1241d464b.png";